import React from 'react';
import PageWrapper from '../../components/ui/PageWrapper';
import FadeUp from '../../components/ui/FadeUp';
import CTASection from '../../components/sections/CTASection';
import { Link } from 'react-router-dom';

const propertyTypes = [
  { icon: '🏢', name: 'Apartments & Flats' },
  { icon: '🏠', name: 'Independent Houses & Villas' },
  { icon: '🌾', name: 'Farmhouses' },
  { icon: '📐', name: 'Residential Plots' },
  { icon: '🏡', name: 'Bungalows' },
  { icon: '🔨', name: 'Renovation & Interior Vastu' },
];

export default function Residential() {
  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 70% 50%, rgba(232,135,26,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Services / Residential</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>
              Residential Vastu
            </h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 560, lineHeight: 1.8 }}>
              Create harmonious living spaces that support health, prosperity, and family well-being through authentic Vastu principles.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div className="residential-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'start' }}>
            <div>
              <FadeUp>
                <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 28, marginBottom: 20 }}>
                  Properties We Consult For
                </h2>
                <p style={{ fontSize: 15, lineHeight: 1.9, opacity: 0.7, marginBottom: 32 }}>
                  Your home is more than walls and a roof — it's a living energy field that profoundly influences your health, relationships, finances and happiness. Our personalized Vastu consultations ensure recommendations that are both effective and easy to implement.
                </p>
              </FadeUp>
              <FadeUp delay={0.2}>
                <div className="property-types-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  {propertyTypes.map((r, i) => (
                    <div key={i} style={{
                      background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.1)',
                      borderRadius: 10, padding: '20px 16px'
                    }}>
                      <p style={{ fontSize: 24, marginBottom: 8 }}>{r.icon}</p>
                      <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 15 }}>{r.name}</p>
                    </div>
                  ))}
                </div>
              </FadeUp>
            </div>

            <div>
              <FadeUp delay={0.1}>
                <div style={{ background: 'rgba(232,135,26,0.04)', border: '1px solid rgba(232,135,26,0.15)', borderRadius: 12, padding: 28, marginBottom: 24 }}>
                  <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, color: '#E8871A', marginBottom: 16 }}>
                    What We Analyse
                  </h3>
                  {['Main entrance & direction', 'Room placement & layout', 'Kitchen & bathroom positioning', 'Bedroom & sleeping direction', 'Living room & family areas', 'Study & work-from-home spaces', 'Balcony & open areas', 'Colour & interior recommendations'].map((item, i) => (
                    <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                      <span style={{ color: '#E8871A' }}>✦</span>
                      <span style={{ fontSize: 14, opacity: 0.75 }}>{item}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact" className="btn-primary" style={{ display: 'block', textAlign: 'center' }}>
                  Book Residential Consultation
                </Link>
              </FadeUp>
            </div>
          </div>
        </div>
      </section>

      <CTASection />

      <style>{`
        @media (max-width: 1024px) {
          .residential-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
        @media (max-width: 768px) {
          .residential-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .property-types-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </PageWrapper>
  );
}
